module.exports = __webpack_public_path__ + "static/media/TKO-BNB.373c4109.svg";